<template>
    <div class="file-preview-autodetect">
        <template v-if="type === 'image'">
            <img :src="absolute_preview_url" class="img-fluid" alt="">
        </template>
        <template v-else-if="type === 'pdf'">
            <iframe :src="absolute_preview_url" width="100%" height="600"></iframe>
        </template>
    </div>
</template>

<script>
import uploads from "@/mixins/uploads";

export default {
    name: "FilePreviewAutoDetect",
    mixins: [uploads],
    props: ['files', 'fallbackUrl'],

    computed: {

        absolute_preview_url(){
            return this.uploads.url(this.preview_url);
        },

        preview_url(){
            if( this.file ){
                if( this.file.preview_url ) return this.file.preview_url;
                return this.file.url;
            }
            return this.fallbackUrl;
        },

        file(){
            const with_preview = this.files.filter(f => f?.preview_url && f?.url && f?.mime)
            if( with_preview.length ) return with_preview[0];
            return null;
        },

        type(){
            if( this.file?.mime ){
                switch (this.file.mime){
                    case 'image/png':
                    case 'image/jpg':
                    case 'image/jpeg':
                    case 'image/gif':
                    case 'image/bmp':
                        return 'image';

                    case 'application/pdf':
                        return 'pdf';

                    default: return 'other';
                }
            }
            return 'image';
        },

    }

}
</script>

<style scoped>

</style>
